import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';
import ApiKeyInput from '../components/ApiKeyInput';
import CharacterSetup from '../components/CharacterSetup';
import OutOfCreditsCard from '../components/OutOfCreditsCard';
import ScenarioSelection from '../components/ScenarioSelection';
import Layout from '../components/Layout';
import { generatePartner } from '../shared/persona';

const HomePage = () => {
  const { isKeyValid, trialMode, trialBlock } = useApiKey();
  const navigate = useNavigate();
  // The card the user picked, held while they name the person they'll talk to.
  const [pending, setPending] = useState(null);

  // Can the user actually enter the app? Either they've saved their own key, or
  // they're in an active trial that hasn't been blocked.
  const trialActive = trialMode && trialBlock !== 'trial_exhausted' && trialBlock !== 'owner_out_of_credits';
  const canPractice = isKeyValid || trialActive;

  // Picking a scenario asks who the user is talking to before opening the chat.
  const handleSelectScenario = (scenario, realistic) => setPending({ scenario, realistic });

  // Name and (optionally) description in hand, build the specific person and
  // drop into the chat. The partner travels in router state.
  const handleStart = ({ name, description }) => {
    const { scenario, realistic } = pending;
    const character = generatePartner(scenario, { name, description });
    setPending(null);
    navigate('/chat', { state: { scenario, character, realistic } });
  };

  const renderEntry = () => {
    if (trialBlock === 'owner_out_of_credits') {
      return <OutOfCreditsCard />;
    }
    if (!canPractice) {
      const notice = trialBlock === 'trial_exhausted'
        ? "You've used your 2 free chats. Enter your own Anthropic API key to keep practicing."
        : undefined;
      return <ApiKeyInput notice={notice} />;
    }
    return (
      <>
        <ScenarioSelection onSelectScenario={handleSelectScenario} />
        {pending && (
          <CharacterSetup
            scenario={pending.scenario}
            onStart={handleStart}
            onCancel={() => setPending(null)}
          />
        )}
      </>
    );
  };

  return <Layout>{renderEntry()}</Layout>;
};

export default HomePage;
